import type { DownloadParams, JsonData, UrlData } from "."

export const getFileNameFromPath = (path: string) => {
  try {
    return path.split("/").pop()?.split(".")?.[0] || ""
  } catch {
    return ""
  }
}

export const downloadFileFromUrl = (
  values: UrlData,
  params?: DownloadParams
) => {
  try {
    const { url, filename } = values
    const oldOnBeforeUnloadValue = window.onbeforeunload
    const link = document.createElement("a")

    link.setAttribute("download", filename)
    link.setAttribute("href", url)

    if (params?.target) link.setAttribute("target", params.target)

    window.onbeforeunload = null
    link.click()
    window.onbeforeunload = oldOnBeforeUnloadValue
  } catch (error) {
    params?.logger?.error("Failed to download file from url", {
      url: values?.url,
      filename: values?.filename,
      error,
      reason: error instanceof Error ? error.message : "unknown"
    })
  }
}

export const downloadFileFromJSON = (
  values: JsonData,
  params?: DownloadParams
) => {
  try {
    const { data, filename } = values
    const fileToSave = encodeURI(
      "data:text/json;charset=utf-8," + JSON.stringify(data, null, 2)
    )

    downloadFileFromUrl({ filename, url: fileToSave })
  } catch (error) {
    params?.logger?.error("Failed to download JSON", {
      error,
      data: values?.data,
      url: values?.filename,
      reason: error instanceof Error ? error.message : "unknown"
    })
  }
}

export const downloadFileFromText = (
  text: string,
  params: DownloadParams = {}
) => {
  try {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" })
    const a = document.createElement("a")
    a.href = URL.createObjectURL(blob)
    a.download = params.filename || "download.txt"
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(a.href)
  } catch (error) {
    params?.logger?.error("Failed to download text as file", {
      error,
      filename: params.filename,
      reason: error instanceof Error ? error.message : "unknown"
    })
  }
}

export const getFileNameFromDisposition = (
  contentDisposition: string | null,
  fallback = "export.csv"
): string => {
  if (!contentDisposition) return fallback

  const utf8Match = contentDisposition.match(/filename\*=\s*([^']*)''([^;]+)/i)

  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[2])
    } catch {
      // Nothing to do, fallback to other methods
    }
  }

  const plainMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)

  if (plainMatch) return plainMatch[1].trim()

  return fallback
}
